import React from "react";
import AdminNavbar from "../Navbar/AdminNavbar";
import "./AdminLayout.css";

export default function AdminLayout({ children }) {
  return (
    <div className="admin-layout">
      <div className="item-c">
        <AdminNavbar />
      </div>
      <div className="item-b">{children}</div>
    </div>
  );
}
